import React, { useEffect } from "react";
import { Checkbox, CheckboxGroup } from "@hdir/ui/checkbox";

import type { FilterOptionsProps } from "../../../site/parts/listSearch/type.d";

export default function FilterOptions(props: Readonly<FilterOptionsProps>) {
  const {
    filterLists,
    currentFilter,
    handleCheckboxChange,
    setCountCheckedHelper,
    isCloseable,
    onFetchWithFilter
  } = props;

  // Filter when filter value is selected
  if (!isCloseable) {
    useEffect(() => {
      onFetchWithFilter(false);
    }, [currentFilter]);
  }

  return (
    <div className="flex nt-flex-col tablet:nt-flex-row">
      {filterLists?.length > 0 && filterLists.map((list, listIndex) => (
        list?.filterList.length > 0 && (
          <div className={`w-full ${!isCloseable ? "nonCloseable" : ""}`} key={list.id}>
            <CheckboxGroup
              key={list.id}
              name={list.label}
              label={<h3 className="text-lg font-bold">{list.label}</h3>}
              value={currentFilter[listIndex]?.values}
              onChange={(value) => {
                handleCheckboxChange(value, list.field);
              }}
            >
              {list?.filterList.map((filterItem) => (
                <Checkbox
                  key={filterItem.id}
                  label={filterItem.displayName ?? filterItem.value}
                  name={filterItem.value}
                  value={filterItem.value}
                  onChange={(e) => { setCountCheckedHelper(e); }}
                  aria-describedby={`Filtrer søketreff på ${filterItem.value}`}
                />
              ))}
            </CheckboxGroup>
          </div>
        )))}
    </div>
  );
}
